// Function to handle intersection changes
const handleIntersect = (entries, observer) => {
  entries.forEach(entry => {
    // Check if the target is in view
    if (entry.isIntersecting) {
      // Perform any action you need when the element comes into view
      // For example, you can add a class to the element
      entry.target.setAttribute('open', '')
    }
  })
}

// Options for the IntersectionObserver
const options = {
  root: null, // Use the viewport as the bounding box
  rootMargin: '30px', // Add 30px tolerance
  threshold: 0, // Trigger as soon as even one pixel is visible
}

// Create the observer with the handler and options
const observer = new IntersectionObserver(handleIntersect, options)

// Target elements to observe
const targets = document.querySelectorAll('[data-expand-inview="true"]')

// Start observing each target
if (targets != null) {
  targets.forEach(target => observer.observe(target))
}
